import { Component, OnInit } from '@angular/core';
import { PhrutillsService } from '../../generic/phrutills.service';
declare var $: any;
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  ischeckinThorughCard: boolean = false;
  supportMailLink: string = 'mailto:support@talkphr.com?subject=Breeze%20Check-In%20Support';
  constructor(private _phrutilService: PhrutillsService) { }

  ngOnInit() {
    this._phrutilService.CheckinThroughCard$.subscribe(checkinType => {
      if (checkinType == "scan") {
        this.ischeckinThorughCard = true;
      } else {
        this.ischeckinThorughCard = false;
      }
    });
    this.buildSupportMailLink();
  }
  buildSupportMailLink() {
    const accountNumber = localStorage.getItem('ptcode');

    //const subject = `Breeze Check-In Support - ${accountNumber}`;
    const subject = accountNumber
      ? `Breeze Check-In Support - ${accountNumber}`
      : `Breeze Check-In Support`;
    this.supportMailLink = `mailto:support@talkphr.com?subject=${encodeURIComponent(subject)}`;
  }
}
